const WHATSAPP_URL = "https://wa.me/33751514276";

const WhatsAppIcon = ({ size = 24 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.2 3 3.66 8.54 3.66 15.37c0 2.18.57 4.3 1.65 6.17L3.5 28.5l7.14-1.87a12.3 12.3 0 0 0 5.4 1.24h.01c6.83 0 12.37-5.54 12.37-12.37S22.87 3 16.04 3zm0 22.36h-.01a10.2 10.2 0 0 1-5.2-1.42l-.37-.22-3.87 1.01 1.03-3.77-.24-.39a10.24 10.24 0 0 1-1.57-5.45c0-5.67 4.61-10.28 10.29-10.28 2.75 0 5.33 1.07 7.27 3.01a10.22 10.22 0 0 1 3.01 7.27c0 5.68-4.61 10.24-10.34 10.24zm5.64-7.68c-.31-.16-1.83-.9-2.11-1-.28-.1-.49-.16-.7.15-.2.31-.79 1-.97 1.21-.18.2-.36.23-.67.08-.31-.16-1.3-.48-2.48-1.53-.92-.82-1.54-1.83-1.72-2.14-.18-.31-.02-.48.13-.63.14-.14.31-.36.47-.54.15-.18.2-.31.31-.52.1-.2.05-.39-.03-.54-.08-.16-.7-1.68-.95-2.3-.25-.6-.51-.52-.7-.53l-.6-.01c-.2 0-.54.08-.82.39-.28.31-1.08 1.06-1.08 2.57 0 1.52 1.1 2.98 1.26 3.19.15.2 2.17 3.32 5.26 4.65.74.32 1.31.51 1.76.65.74.24 1.41.2 1.94.12.59-.09 1.83-.75 2.08-1.47.26-.72.26-1.34.18-1.47-.08-.13-.28-.2-.59-.36z" />
  </svg>
);

export const WhatsAppButton = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="WhatsApp"
    className="fixed bottom-6 right-6 z-[60] group flex items-center gap-3"
  >
    <span className="hidden md:block opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-400 text-[0.62rem] tracking-[0.25em] uppercase text-[var(--elt-gold-light)] bg-[#0B0C0E]/90 border border-[var(--elt-line)] px-4 py-2 backdrop-blur">
      +33 7 51 51 42 76
    </span>
    <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#0B0C0E]/85 border border-[var(--elt-gold)]/50 text-[var(--elt-gold)] backdrop-blur-xl shadow-[0_4px_24px_rgba(0,0,0,0.5)] hover:bg-[var(--elt-gold)] hover:text-[#0B0C0E] hover:border-[var(--elt-gold)] transition-colors duration-400">
      <WhatsAppIcon size={26} />
    </span>
  </a>
);

export { WhatsAppIcon, WHATSAPP_URL };
